/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../models/plaid_link';
import '../../../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "service": {
                "nested": {
                  "GetPlaidLinkRequest": {
                    "fields": {
                      "customerId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "GetPlaidLinkResponse": {
                    "fields": {
                      "plaidLink": {
                        "type": ".squareup.sfs.external.models.PlaidLink",
                        "id": 1,
                        "rule": "optional"
                      },
                      "errors": {
                        "type": ".squareup.connect.v2.resources.Error",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.GetPlaidLinkRequest && !$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.GetPlaidLinkResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE GetPlaidLinkRequest @ squareup/sfs/external/services/external_bank_account/get_plaid_link.proto at 9:1
 */
export const GetPlaidLinkRequest = $root.lookupType('squareup.sfs.external.service.GetPlaidLinkRequest');
fixType(GetPlaidLinkRequest, {
  customerId: {
    required: true
  }
});
Builder.createAndAttachToType(GetPlaidLinkRequest);
/**
 * SOURCE GetPlaidLinkResponse @ squareup/sfs/external/services/external_bank_account/get_plaid_link.proto at 16:1
 */
export const GetPlaidLinkResponse = $root.lookupType('squareup.sfs.external.service.GetPlaidLinkResponse');
fixType(GetPlaidLinkResponse);
Builder.createAndAttachToType(GetPlaidLinkResponse);